const config = {
  apiGateway: {
    URL: "https://ia3f2mam1e.execute-api.ca-central-1.amazonaws.com/v1/",
    AUTH: "https://va0vw30wa4.execute-api.ca-central-1.amazonaws.com/v1/",
    REGION: "ca-central-1",
  },
  self_register_enabled: true,
  fef_ui_version: "2.0.62",
};

var siteConfig = { title: 'ACPI Client Portal' };

export { config, siteConfig };
